import { AfterViewInit, Component, Input, OnInit } from '@angular/core'
import { NbDialogRef, NbDialogService } from '@nebular/theme'
import { ITurnInfo } from 'src/app/@core/services/working.service'
import _ from 'lodash'
import { ButtonType, PvsFormDialogComponent, PvsFormResponse } from '../pvs-form-dialog/pvs-form-dialog.component'
import { ViewChild, ElementRef } from '@angular/core'
import { ScanBarcodeComponent } from '../scan-barcode/scan-barcode.component'
import { GiftCardService } from '../../@core/services/gift-card.service'
import { SharedService } from '../../@core/services/shared.service'
import { format, parseISO } from 'date-fns'

export enum ETurnInputMode {
    NEW,
    UPDATE,
    DELETE,
}

export interface ITurnInputRedeemComponentResponse {
    // workingTurnId?: number
    giftCardId: number
    code: string
    amt: number
    note?: string
    giftCard: any
}

@Component({
    templateUrl: './turn-input-redeem.component.html',
    styleUrls: ['./turn-input-redeem.component.scss'],
    selector: 'app-turn-input-redeem',
})
export class TurnInputRedeemComponent implements OnInit, AfterViewInit {
    @Input() redeems: Array<ITurnInputRedeemComponentResponse>
    @Input() workingTurnId: number = null
    EMode = ETurnInputMode
    mode: ETurnInputMode
    redeemAmt: number = 0
    tmpRedeems: Array<any> = []
    protected dialogRef: NbDialogRef<any>
    @ViewChild('amt', { static: false }) amtRef: ElementRef

    constructor(
        public sharedService: SharedService,
        dialogRef: NbDialogRef<any>,
        private dialogService: NbDialogService,
        private giftCardService: GiftCardService
    ) {
        this.dialogRef = dialogRef
    }

    ngOnInit() {
        this.mode = !this.workingTurnId ? ETurnInputMode.NEW : ETurnInputMode.UPDATE
        if (this.redeems?.length) {
            this.tmpRedeems = [...this.redeems]
            this.getCardInfo()
        }
        this.calcRedeemAmt()
    }
    getCardInfo() {
        if (!this.tmpRedeems.length) {
            return
        }
        const giftCardIdList = this.tmpRedeems.map((e) => e.giftCardId)
        this.giftCardService.checkMultipleBalance(giftCardIdList, this.workingTurnId).subscribe((res) => {
            // map to data
            for (const t of this.tmpRedeems) {
                t.giftCard = res.data.find((e) => e.id === t.giftCardId) || null
                if (t.giftCard?.expiredAt) {
                    t.giftCard.isExpired =
                        format(parseISO(t.giftCard.expiredAt), 'yyyyMMdd') < format(new Date(), 'yyyyMMdd')
                }
                t.code = t.giftCard?.code
            }
        })
    }
    ngAfterViewInit(): void {
        if (this.tmpRedeems.length === 0) {
            this.onScanNewGC()
        }
    }
    onOk() {
        // check
        this.calcRedeemAmt()
        for (const c of this.tmpRedeems) {
            const availableAmt = c.giftCard?.availableRedeemBalance || 0
            if (c.amt > availableAmt) {
                return this.sharedService.showErrorMessage(
                    `The redeem amt ($${c.amt}) is greater then available amt ($${availableAmt})`
                )
            }
        }
        // return
        const redeems: Array<ITurnInputRedeemComponentResponse> = this.tmpRedeems.map((e) => {
            return {
                workingTurnId: e.workingTurnId,
                giftCardId: e.giftCardId,
                code: e.code,
                amt: e.amt,
                note: e.note,
                giftCard: e.giftCard,
            }
        })
        this.dialogRef.close({
            redeemAmt: this.redeemAmt,
            redeems: redeems,
        })
    }
    onCancel() {
        this.dialogRef.close()
    }
    onScanNewGC() {
        this.dialogService
            .open(ScanBarcodeComponent, {
                context: {},
            })
            .onClose.subscribe((code) => {
                if (!code) {
                    return
                }
                // check code is exists
                const existed = this.tmpRedeems.find((e) => e.code === code)
                if (!!existed) {
                    return this.sharedService.showErrorMessage(`This card (${code}) is exists already!`)
                }
                // get card info
                this.giftCardService.checkCode(code).subscribe((response) => {
                    if (!response.data?.isValid) {
                        return this.sharedService.showErrorMessage('This card is invalid')
                    }
                    if (!response.data?.giftCard) {
                        return this.sharedService.showErrorMessage('This card information is not found')
                    }
                    this.giftCardService
                        .checkMultipleBalance([response.data.giftCard.id], this.workingTurnId)
                        .subscribe((res) => {
                            const giftCard = res.data?.[0]
                            if (giftCard?.expiredAt) {
                                giftCard.isExpired =
                                    format(parseISO(giftCard.expiredAt), 'yyyyMMdd') < format(new Date(), 'yyyyMMdd')
                            }
                            const el: ITurnInputRedeemComponentResponse = {
                                giftCardId: giftCard.id,
                                code: giftCard.code,
                                amt: 0,
                                note: null,
                                giftCard: giftCard,
                            }
                            this.tmpRedeems = this.tmpRedeems.concat([el])
                        })
                })
            })
    }
    calcRedeemAmt() {
        const total = this.tmpRedeems.reduce((previousValue, currentValue) => previousValue + currentValue.amt, 0)
        this.redeemAmt = Math.round(total * 100) / 100
    }
    onRedeemAmtChange() {
        this.calcRedeemAmt()
    }
    onRemoveCard(code) {
        for (let i = 0; i < this.tmpRedeems.length; i++) {
            if (this.tmpRedeems[i].code === code) {
                // remove
                this.tmpRedeems.splice(i, 1)
                this.calcRedeemAmt()
                return
            }
        }
    }
}
